import type { RejectJoinRequestBody, RejectJoinRequestData } from 'api/dist/routes/auth/reject-join-request/index.js'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useClientApi } from '@/setup/api-client'

export type IRejectJoinRequestBody = RejectJoinRequestBody
export type IRejectJoinRequestData = RejectJoinRequestData

/**
 * Flags the requester as rejected (server-side) when an admin declines their team-join request,
 * so the requester sees the "Access request rejected" modal on `/routing` instead of silently
 * auto-creating a personal workspace. Called after Clerk's `request.reject()` commits; the marker
 * is idempotent so an ambiguous marker failure can be retried once safely. An ambiguous Clerk
 * rejection never calls this mutation because the Backend API cannot verify request state.
 */
export function useRejectJoinRequestMutation() {
    const api = useClientApi()
    return useApiMutation<IRejectJoinRequestData, IRejectJoinRequestBody>({
        mutationFn: async (body) => {
            const res = await api.post<IRejectJoinRequestData, IRejectJoinRequestBody>(
                '/auth/reject-join-request',
                body
            )
            return res.data
        },
    })
}
